<template>
<div>
    <div v-if="loading" class="overlay">
        <div class="loader">
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "loader",

    props: {
        loading: false
    }

};
</script>

<style scoped>
.loader {
    border: 1px solid #336699;
    /* Light grey */
    border-top: 1px solid transparent;
    /* Blue */
    border-radius: 50%;
    width: 2em;
    height: 2em;
    animation: spin .8s linear infinite;

    display: block;
    margin-top: 16em;
    margin-left: auto;
    margin-right: auto;
    z-index: 1000;

}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.overlay {
    position: fixed;
    /* Sit on top of the page content */
    display: block;
    width: 100%;
    /* Full width (cover the whole page) */
    height: 100%;
    /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* Black background with opacity */
    /* background-color: rgba(0,0,0,0.5); */
    z-index: 10000;
    /* Specify a stack order in case you're using a different order for other elements */
    /* cursor: pointer; */
    /* Add a pointer on hover */
}
</style>
